module.exports = __webpack_public_path__ + "static/media/Rapport_CJ_AREVA_2016.7511954b.pdf";